import { ArrowDownCircleIcon } from "@heroicons/react/24/solid";
const DownloadButton = ({
  buttonValue = "Download",
  className = "",
  onClick,
  type = "button",
  disabled = false,
}) => {
  return (
    <button
      type={type}
      value={buttonValue}
      onClick={onClick}
      disabled={disabled}
      className={
        (disabled
          ? "cursor-not-allowed border text-quinary opacity-50  border-quinary "
          : "text-quinary border-quinary opacity-100") +
        `hover:scale-90 transition duration-500 shadow-md border-quinary bg-tranparent hover:bg-quinary 
        text-quinary group relative flex justify-center py-1 px-3 border  text-xs 
        font-medium rounded-full hover:text-white 
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quinary focus:ring-opacity-70$ ${className}`
      }
    >
      <div className="flex flex-row">
        <ArrowDownCircleIcon className="h-4 w-4 mr-1" />
        <p className=" "> {buttonValue}</p>
      </div>
    </button>
  );
};
export default DownloadButton;
